











 















const node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "votesRemaining",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateRetroMaxVotesMutation_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RetrospectiveMeeting",
      "kind": "LinkedField",
      "name": "meeting",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalVotes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxVotesPerGroup",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "RetrospectiveMeetingMember",
          "kind": "LinkedField",
          "name": "viewerMeetingMember",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UpdateRetroMaxVotesSuccess",
  "abstractKey": null
};
})();

(node ).hash = "4df43c407f9fa3d99975438ef4afa07b";

export default node;
